import React from 'react';
import compose from 'recompose/compose';
import defaultProps from 'recompose/defaultProps';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import withPropsOnChange from 'recompose/withPropsOnChange';
import GoogleMapReact from 'google-map-react';
import ClusterMarker from './markers/cluster-marker';
import SimpleMarker from './markers/simple-marker';
import supercluster from 'points-cluster';

export const gMap = ({
  style,
  hoverDistance,
  options,
  mapProps: { center, zoom },
  onChange,
  onChildClick,
  onChildMouseEnter,
  onChildMouseLeave,
  clusters,
  bootstrapURLKeys,
  className,
  onMarkerClick,
  onClick
}) => (
  <GoogleMapReact
    style={style}
    options={options}
    hoverDistance={hoverDistance}
    center={center}
    zoom={zoom}
    onChange={onChange}
    onChildMouseEnter={onChildMouseEnter}
    onChildMouseLeave={onChildMouseLeave}
    onChildClick={onChildClick}
    bootstrapURLKeys={bootstrapURLKeys}
    className={className}
    onClick={onClick}
  >
    {clusters.map((markerProps, i) => {
      const { numPoints } = markerProps;
      return numPoints === 1 ? (
        <SimpleMarker
          key={markerProps.points[0].id}
          {...markerProps} /*onClick={()=>(onMarkerClick && onMarkerClick(markerProps))} */
        />
      ) : (
        <ClusterMarker
          key={i}
          {...markerProps} /*onClick={()=>(onMarkerClick && onMarkerClick(markerProps))}*/
        />
      );
    })}
  </GoogleMapReact>
);

export const gMapHOC = compose(
  defaultProps({
    clusterRadius: 60,
    hoverDistance: 30,
    options: {
      minZoom: 3,
      maxZoom: 20,
      mapTypeControl: true
    },
    style: {
      position: 'relative',
      margin: 0,
      padding: 0,
      flex: 1
    }
  }),
  // withState so you could change markers if you want
  // withState(
  //   'markers',
  //   'setMarkers',
  //   []
  // ),
  withState('hoveredMarkerId', 'setHoveredMarkerId', -1),
  withState(
    'mapProps',
    'setMapProps',
    ({ defaultCenter = { lat: 26.212878, lng: -81.718964 }, defaultZoom = 11 }) => ({
      center: defaultCenter,
      zoom: defaultZoom
    })
  ),
  // describe events
  withHandlers({
    onChange:
      ({ setMapProps }) =>
      ({ center, zoom, bounds }) => {
        setMapProps({ center, zoom, bounds });
      },

    onChildMouseEnter:
      ({ setHoveredMarkerId }) =>
      (hoverKey, markerProps) => {
        setHoveredMarkerId(hoverKey);
      },

    onChildMouseLeave:
      ({ setHoveredMarkerId }) =>
      (/* hoverKey, childProps */) => {
        setHoveredMarkerId(-1);
      },

    onChildClick: props => (markerKey, markerProps) => {
      const { setMapProps, onMarkerClick, mapProps } = props;

      if (markerProps.points.length > 1) {
        setMapProps({
          center: {
            lat: markerProps.lat,
            lng: markerProps.lng
          },
          zoom: mapProps.zoom + 1
        });
      }

      if (onMarkerClick) {
        onMarkerClick(props, markerKey, markerProps);
      }
    }
  }),
  // precalculate clusters if markers data has changed
  withPropsOnChange(
    ['markers'],
    ({ markers = [], clusterRadius, options: { minZoom, maxZoom } }) => ({
      getCluster: supercluster(markers, {
        minZoom, // min zoom to generate clusters on
        maxZoom: maxZoom - 1, // max zoom level to cluster the points on
        radius: clusterRadius // cluster radius in pixels
      })
    })
  ),
  // get clusters specific for current bounds and zoom
  withPropsOnChange(['mapProps', 'getCluster'], ({ mapProps, getCluster }) => ({
    clusters: mapProps.bounds
      ? getCluster(mapProps).map(({ wx, wy, numPoints, points }) => ({
          lat: wy,
          lng: wx,
          text: numPoints,
          numPoints,
          points,
          id: `${numPoints}_${points[0].id}`
        }))
      : []
  })),
  // set hovered
  withPropsOnChange(['clusters', 'hoveredMarkerId'], ({ clusters, hoveredMarkerId }) => ({
    clusters: clusters.map(({ id, ...cluster }) => ({
      ...cluster,
      hovered: id === hoveredMarkerId
    }))
  }))
);

export default gMapHOC(gMap);



// WEBPACK FOOTER //
// ./src/components/cluster-map/cluster-map.js